<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">Detail Report EDC</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Aggregator Name"
            :data="editedItem"
            :valueData="editedItem.aggregator_name"
            noGutters
          />
          <data-detail-row
            label="Merchant Name"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="MID"
            :data="editedItem"
            :valueData="editedItem.mid"
            noGutters
          />
          <data-detail-row
            label="Transaction Type"
            :data="editedItem"
            :valueData="editedItem.jenis_trx"
            noGutters
          />
          <data-detail-row
            label="Issuer Name"
            :data="editedItem"
            :valueData="editedItem.issuer_name"
            noGutters
          />
          <data-detail-row
            label="Customer PAN"
            :data="editedItem"
            :valueData="editedItem.customer_pan"
            noGutters
          />
          <data-detail-row
            label="Acquirer Name"
            :data="editedItem"
            :valueData="editedItem.acquirer_name"
            noGutters
          />
          <data-detail-row
            label="Amount"
            :data="editedItem"
            :valueData="editedItem.amount"
            noGutters
          />
          <data-detail-row
            label="MDR"
            :data="editedItem"
            :valueData="editedItem.mdr_fee"
            noGutters
          />
          <data-detail-row
            label="Net Amount"
            :data="editedItem"
            :valueData="editedItem.net_amount"
            noGutters
          />
          <data-detail-row
            label="Transaction Date"
            :data="editedItem"
            :valueData="editedItem.trx_date"
            noGutters
          />
          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            label="Setlement Status"
            :data="editedItem"
            :valueData="editedItem.settlement_status"
            noGutters
          />
          <data-detail-row
            label="SOF"
            :data="editedItem"
            :valueData="editedItem.sof"
            noGutters
          />
          <data-detail-row
            label="Proc Date "
            :data="editedItem"
            :valueData="editedItem.proc_date"
            noGutters
          />
          <data-detail-row
            label="GB "
            :data="editedItem"
            :valueData="editedItem.gb"
            noGutters
          />
          <data-detail-row
            label="OB "
            :data="editedItem"
            :valueData="editedItem.ob"
            noGutters
          />
          <data-detail-row
            label="SEQ "
            :data="editedItem"
            :valueData="editedItem.seq"
            noGutters
          />
          <data-detail-row
            label="Type "
            :data="editedItem"
            :valueData="editedItem.type"
            noGutters
          />
          <data-detail-row
            label="Payment Date "
            :data="editedItem"
            :valueData="editedItem.payment_date"
            noGutters
          />
          <data-detail-row
            label="Auth "
            :data="editedItem"
            :valueData="editedItem.auth"
            noGutters
          />
          <data-detail-row
            label="TID "
            :data="editedItem"
            :valueData="editedItem.tid"
            noGutters
          />
          <data-detail-row
            label="PTR "
            :data="editedItem"
            :valueData="editedItem.ptr"
            noGutters
          />
          <data-detail-row
            label="Rate "
            :data="editedItem"
            :valueData="editedItem.rate"
            noGutters
          />
          <data-detail-row
            label="Disc Amount "
            :data="editedItem"
            :valueData="editedItem.disc_amount"
            noGutters
          />
          <data-detail-row
            label="Air Fare "
            :data="editedItem"
            :valueData="editedItem.air_fare"
            noGutters
          />
          <data-detail-row
            label="Plan "
            :data="editedItem"
            :valueData="editedItem.plan"
            noGutters
          />
          <data-detail-row
            label="SS Amount "
            :data="editedItem"
            :valueData="editedItem.ss_amount"
            noGutters
          />
          <data-detail-row
            label="SS Fee Type "
            :data="editedItem"
            :valueData="editedItem.ss_fee_type"
            noGutters
          />
          <data-detail-row
            label="Flag "
            :data="editedItem"
            :valueData="editedItem.flag"
            noGutters
          />
          <data-detail-row
            label="Merchant Account "
            :data="editedItem"
            :valueData="editedItem.merchant_account"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  components: {
    DataDetailRow: () => import('../detail/DataDetailRow.vue'),
  },
  props: ['editedItem'],
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
